export default "__VITE_ASSET__CPfyZFCN__"